import { Directive, EventEmitter, AfterViewInit, Output, ElementRef } from '@angular/core';

@Directive({
  selector: '[onRendered]'
})
export class OnRenderedDirective implements AfterViewInit {
  @Output() onRendered = new EventEmitter<void>(); // Event emitter to notify when element is rendered

  constructor(private el: ElementRef) { }

  ngAfterViewInit(): void {
    this.onRendered.emit(); // Emit an event after the view initialization
  }
}